import store from "../store"

export default (message, status = "primary") => {
  store.dispatch("notify", {
    message,
    status
  })
}
